/* eslint-disable */

const friendBot = () => {
  const friendlyMessages = [
    "You look beautiful today! 😍",
    "I hope you're having a productive day 🙂",
    "I saw your last PR and darling, you're rocking it! 🧠",
    "How may I help you today 🙇‍",
    "Remember to stay hydrated 🌊",
    "Did you ever hear about the tree that owned itself? 🌲 https://bit.ly/1YOriqq",
    "Fun fact, you are the master of your own destiny. You can literally achieve whatever future you want for yourself! 🧘",
    "WebPack getting you down? I know that one! Why not become a goat herder instead? 🐐",
    "Think of all the code that went into compiling this app and me. It all works, not even a syntax error. Thank you 🤖",
    "There's lots of people who commute to london every day for work. You're not one of them 🚂",
  ];
  const friendlyMessage = `




  🙋‍Welcome developer! ${friendlyMessages[Math.floor(Math.random() * friendlyMessages.length)]}





  `;
  return friendlyMessage;
}


export { friendBot }

